"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpPaginator = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const core_1 = require("@integro/core");
const paginator_html_1 = __importDefault(require("./paginator.html"));
let ItpPaginator = class ItpPaginator extends vue_1.default {
    totalCount;
    pageStart;
    currentPage;
    numberOfPages;
    isLoading;
    isReloading;
    dataItems;
    dataSource;
    pageSize;
    data() {
        return {
            isLoading: false,
            isReloading: false,
            dataItems: [],
            pageStart: null,
            pageCount: null,
            totalCount: 20,
            currentPage: null,
            numberOfPages: null
        };
    }
    onDataSourceChanged() {
        if (this.dataSource) {
            this.load();
        }
    }
    created() {
        const unsub = this.$router.afterEach((to, from) => {
            if (to == this.$route) {
                if (this.currentPage !== this.getCurrentPage()) {
                    this.setCurrentPage(this.getCurrentPage());
                }
            }
        });
        this.$once('hook:beforeDestroy', () => unsub());
        this.setCurrentPage(this.getCurrentPage());
    }
    load() {
        this.isLoading = true;
        return this._load().finally(() => (this.isLoading = false));
    }
    reload() {
        this.isReloading = true;
        return this._load().finally(() => (this.isReloading = false));
    }
    _load() {
        return this.dataSource.load(this.currentPage).then(result => {
            this.numberOfPages = Math.ceil(result.totalCount / result.pageSize);
            this.totalCount = result.totalCount;
            this.dataItems = result.data;
        });
    }
    linkGen(pageNum) {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
    }
    getCurrentPage() {
        const p = this.$route.query['page'];
        const n = Array.isArray(p) ? p[0] : p;
        return _.isString(n) ? parseInt(n) : 1;
    }
    setCurrentPage(page) {
        page = page || 1;
        if (this.currentPage !== page) {
            this.currentPage = page;
            this._load();
        }
    }
    get loading() {
        return this.isLoading || this.isReloading;
    }
    get headerSlotProps() {
        return {
            totalCount: this.totalCount,
            reload: this.reload,
            isReloading: this.isReloading,
            items: this.dataItems
        };
    }
    get slotProps() {
        return {
            totalCount: this.totalCount,
            reload: this.reload,
            isReloading: this.isReloading,
            items: this.dataItems
        };
    }
};
exports.ItpPaginator = ItpPaginator;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpPaginator.prototype, "dataSource", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 10 }),
    __metadata("design:type", Number)
], ItpPaginator.prototype, "pageSize", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('dataSource'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpPaginator.prototype, "onDataSourceChanged", null);
exports.ItpPaginator = ItpPaginator = __decorate([
    (0, vue_property_decorator_1.Component)({ template: paginator_html_1.default })
], ItpPaginator);
//# sourceMappingURL=paginator.js.map